<template>
    <v-container flat style="min-width: 90%">
        <v-window v-model="step" touchless>
            <v-window-item :value="0">
                <UploadDocuments
                    :showFirstPrevious="false"
                    :documentType="'FIXED_ASSETS'"
                    :inExtensions="['csv', 'tsv', 'txt', 'xlsx', 'xls']"
                    :multiple="false"
                    :freeTag="false"
                    :gDrive="true"
                    @fileInput="onFileChanged"
                    @fileDeleted="onFileDeleted"
                    @testFileInput="onTestFileChanged"
                />
            </v-window-item>
            <v-window-item :value="1">
                <ColumnCorrespondence
                    ref="columnComponent"
                    v-if="step > 0 && existingFile"
                    :result="result"
                    :extension="extension"
                    :actions="actions"
                    :ruleManager="ruleManager"
                    :formatColumns="formatColumns"
                    :showSwitchs="false"
                    @columns-chosen="onChosenColumns($event)"
                    @back="step = 0"
                />
            </v-window-item>
        </v-window>
    </v-container>
</template>

<script lang="ts">
import { Component, Prop, Watch, toNative } from "vue-facing-decorator";

import UploadDocuments from "../document/UploadDocuments.vue";
import ColumnCorrespondence from "./ColumnCorrespondence.vue";
import { ImportDocumentBase } from "./ImportDocumentBase";
import OssDataTable from "../ossComponents/ossDataTable2.vue";

import { DialogAction } from "../../services/dialogAction";

@Component({
    components: {
        ColumnCorrespondence,
        OssDataTable,
        UploadDocuments,
    },
    emits: ["documentImported", "width"],
})
export class FixedAssetsImport extends ImportDocumentBase {
    @Prop({ default: null }) actions: { action: DialogAction } | null;

    step = 0;

    beforeMount() {
        this.setActionsButton();
    }

    async onChosenColumns(data) {
        const { importedItems, foundErrors } = data;
        this.importedItems = importedItems;
        if (!foundErrors.length) {
            await this.verifyFixedAssets();
            this.$emit("documentImported", this.importedItems);
        }
    }

    async verifyFixedAssets() {
        // debugger
        // if (this.importedItems.length) {
        //     for(const row of this.importedItems){
        //         if(row.PieceDate){
        //             row.PieceDate = this.getDate(row.PieceDate)
        //         }
        //     }
        // }
        // return [];
    }

    @Watch("step")
    setActionsButton() {
        if (this.actions && this.actions.action) {
            if (this.step === 0) {
                this.actions.action.display = true;
                this.actions.action.title = "Suivant";
                this.actions.action.disabled = () => {
                    return !this.existingFile;
                };
                this.actions.action.function = () => {
                    this.step++;
                };
            } else if (this.step === 1) {
                this.actions.action.display = true;
                this.actions.action.title = "Suivant";
                if (this.$refs.columnComponent) {
                    //@ts-ignore
                    this.$refs.columnComponent.setActionButton();
                }
                //@ts-ignore
                this.actions.action.loading = () => {
                    return this.verifLoading;
                };
            }
        }
        this.$emit("width");
    }
}

export default toNative(FixedAssetsImport);
</script>
